export const banners = [
  {
    id: "b1",
    workId: "m1",
    title: "星际迷航者",
    subtitle: "科幻 · 冒险 · 2024",
    tagline: "在浩瀚宇宙中，寻找人类最后的家园",
    image: "https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20space%20scene%20of%20a%20lone%20astronaut%20facing%20a%20giant%20glowing%20ringed%20planet%2C%20vast%20starfield%20with%20warm%20orange%20nebula%20glow%20against%20deep%20charcoal%20darkness%2C%20film%20grain%2C%20dramatic%20moody%20atmosphere%2C%20horizontal%20composition%2C%20no%20text%2C%20highly%20detailed%20cinematic%20photography&width=1920&height=900&seq=baihu-banner-01&orientation=landscape",
  },
  {
    id: "b2",
    workId: "m11",
    title: "火星黎明",
    subtitle: "科幻 · 剧情 · 2025",
    tagline: "在红色荒原上，重新定义家与希望",
    image: "https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20martian%20landscape%20at%20dawn%20with%20a%20lone%20rover%20crossing%20red%20dunes%2C%20warm%20orange%20sunrise%20glow%20against%20deep%20charcoal%20shadows%2C%20film%20grain%2C%20dramatic%20moody%20atmosphere%2C%20horizontal%20composition%2C%20no%20text%2C%20highly%20detailed%20cinematic%20photography&width=1920&height=900&seq=baihu-banner-02&orientation=landscape",
  },
  {
    id: "b3",
    workId: "t1",
    title: "山河故梦",
    subtitle: "古装 · 历史 · 40集",
    tagline: "半生岁月，只为守护一方山河",
    image: "https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20ancient%20chinese%20palace%20courtyard%20at%20dusk%20with%20flaming%20braziers%2C%20warm%20orange%20firelight%20glow%20against%20deep%20charcoal%20shadows%2C%20film%20grain%2C%20dramatic%20moody%20atmosphere%2C%20horizontal%20composition%2C%20no%20text%2C%20highly%20detailed%20cinematic%20photography&width=1920&height=900&seq=baihu-banner-03&orientation=landscape",
  },
  {
    id: "b4",
    workId: "m3",
    title: "长安夜行",
    subtitle: "古装 · 动作 · 2024",
    tagline: "灯火长安之下，暗流从未停歇",
    image: "https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20view%20of%20ancient%20chinese%20city%20lantern%20street%20at%20night%20with%20falling%20snow%2C%20warm%20orange%20lantern%20glow%20against%20deep%20charcoal%20shadows%2C%20film%20grain%2C%20dramatic%20moody%20atmosphere%2C%20horizontal%20composition%2C%20no%20text%2C%20highly%20detailed%20cinematic%20photography&width=1920&height=900&seq=baihu-banner-04&orientation=landscape",
  },
  {
    id: "b5",
    workId: "t3",
    title: "刑警荣耀",
    subtitle: "犯罪 · 悬疑 · 32集",
    tagline: "每一次破案，都是对正义的致敬",
    image: "https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20rainy%20city%20street%20at%20night%20with%20police%20lights%20reflecting%20on%20wet%20asphalt%2C%20warm%20orange%20glow%20against%20deep%20charcoal%20shadows%2C%20film%20grain%2C%20dramatic%20moody%20atmosphere%2C%20horizontal%20composition%2C%20no%20text%2C%20highly%20detailed%20cinematic%20photography&width=1920&height=900&seq=baihu-banner-05&orientation=landscape",
  },
];

export const siteStats = [
  { label: "收录影视作品", value: "12,860" },
  { label: "影视资讯条目", value: "3,420" },
  { label: "覆盖类型标签", value: "86" },
  { label: "每日更新", value: "200+" },
];